<app-file-check-nav />

<form [formGroup]="formGroup" novalidate>
  <div class="container-fluid p-2 border bg-light mb-2">
    <div class="row">
      <div class="col-5 pe-1">
        <div formGroupName="filters">
          <app-client-select
            formControlName="clientIds"
            placeholder="Filter by Client"
            [multiple]="true"
            [autoLoad]="true"
            [listFilters]="{ applicableToReferralClaims: true }"/>
        </div>
      </div>
    </div>
  </div>
</form>

@if (!loading) {
  <div>
    <section class="mt-3">
      <app-pagination-header
        [paging]="paging"
        [label]="'file checks'"
        (pageSizeChange)="onPageSizeChange($event)"
        [includeResetFiltersButton]="true"
        (resetFiltersClick)="onResetFiltersClick()" />
      @if (fileChecks.length > 0) {
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>FILE</th>
              <th>TYPE</th>
              <th>STATUS</th>
              <th>CLIENT</th>
              <th class="text-end">STARTED AT &#x25BC;</th>
              <th class="text-end">DURATION</th>
              <th class="text-end">TOTAL ROWS</th>
              <th class="text-end">PROCESSED</th>
              <th class="text-end">INVALID</th>
              <th class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            @for (fileCheck of fileChecks; track fileCheck) {
              <tr>
                <td>{{ fileCheck.fileName }}</td>
                <td>
                  {{ fileTypeToDisplayName[fileCheck.fileType] }}
                  <div class="text-muted text-nowrap">
                    <small>{{ fileCheck.delimiter }} delimited</small>
                  </div>
                </td>
                <td>
                  <app-file-check-status [fileCheck]="fileCheck" />
                  @if (fileCheck.active) {
                    <div>
                      <button class="btn btn-sm btn-danger" (click)="onCancelClick($event, fileCheck)">
                        <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
                        CANCEL
                      </button>
                    </div>
                  }
                </td>
                <td>{{ fileCheck.client.humanizedName }}</td>
                <td class="text-end">
                  {{ fileCheck.createdAt | date: 'M/d/yyyy h:mm a' }}
                  <div>
                    <small>{{ fileCheck.username }}</small>
                  </div>
                </td>
                <td class="text-end">{{ fileCheck.durationInWords }}</td>
                <td class="text-end">{{ fileCheck.totalRows | number: '' }}</td>
                <td class="text-end">{{ fileCheck.processedRows | number: '' }}</td>
                <td class="text-end">{{ fileCheck.invalidRows | number: '' }}</td>
                <td class="text-center">
                  <div ngbDropdown class="d-inline-block text-nowrap">
                    <button id="downloadDropdown" class="btn btn-secondary" ngbDropdownToggle>Download</button>
                    <div ngbDropdownMenu aria-labelledby="downloadDropdown">
                      <a class="dropdown-item" href="#downloadErrorFile" (click)="onDownloadErrorFileClick($event, fileCheck)"
                        >Error File</a
                        >
                        <a
                          class="dropdown-item"
                          href="#downloadOriginalFile"
                          (click)="onDownloadOriginalFileClick($event, fileCheck)"
                          >Original File</a
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <section class="mt-3"><p>There are no file checks.</p></section>
          }
          <div class="mt-2">
            <app-pagination [paging]="paging" (pageChange)="onPageChange()" />
          </div>
        </section>
      </div>
    } @else {
      <section class="mt-3"><mat-spinner diameter="30" /></section>
    }
